import initCollection from '@sectionsJS/collection';
import initRecentlyViewedProducts from '@sectionsJS/recently-viewed-products';

$(async () => {
  await initCollection();
  initRecentlyViewedProducts();
});
